import i18n from "i18next";

export const translateKey = (key: string, fallback: string = "", prefix: string = ""): string => {
    const translatedName = i18n.t(`${prefix}${key}`);
    if (prefix === "") {
        return translatedName === key ? fallback : translatedName;
    }
    return translatedName.startsWith(prefix) ? fallback : translatedName;
};
